/**
 * AI 助教 CLAUDE.md 构建器
 *
 * 从 ai-ta-prompt.md 模板读取骨架，替换占位符生成最终内容
 */

import promptTemplate from "./ai-ta-prompt.md?raw"

interface ClaudeMdParams {
  courseTitle?: string
  chapterTitle?: string
  chapterIntro?: string
  chapterObjective?: string
  goal?: string
  criteria?: string
  system?: string
}

function buildSection(title: string, content: string | undefined): string {
  if (!content) return ""
  return `# ${title}\n${content}`
}

/**
 * 构建 AI 助教的 CLAUDE.md 内容
 */
export function buildClaudeMd(params: ClaudeMdParams): string {
  const {
    courseTitle = "本",
    chapterTitle = "本章",
    chapterIntro,
    chapterObjective,
    goal,
    criteria,
    system,
  } = params

  let result = promptTemplate

  result = result.replace("{{courseTitle}}", courseTitle)
  result = result.replace("{{chapterTitle}}", chapterTitle)
  result = result.replace(
    "{{chapterIntro}}",
    chapterIntro ? `章节简介：${chapterIntro}` : ""
  )
  result = result.replace(
    "{{chapterObjective}}",
    chapterObjective ? `学习目标：${chapterObjective}` : ""
  )
  result = result.replace("{{goalSection}}", buildSection("本节陪练目标", goal))
  result = result.replace("{{criteriaSection}}", goal && criteria
    ? [
        "# 完成输出（达成陪练目标时必用）",
        `达成标准：${criteria}`,
        "",
        "当你判断学生已达成陪练目标后，输出以下固定格式：",
        "",
        "```",
        "🎉 恭喜你完成了本节陪练！",
        "",
        "**本节目标：** {重复陪练目标}",
        "**你的表现：** {简要评价学生的表现}",
        "```",
      ].join("\n")
    : ""
  )
  result = result.replace("{{systemSection}}", buildSection("附加规则", system))

  // 清理多余空行
  result = result.replace(/\n{3,}/g, "\n\n").trim()

  return result
}
